<div class="loading-overlay">
  <div class="loading-spinner">
    <div class="lds-ripple"><div></div><div></div></div>
  </div>
</div>
